import { gql } from "@apollo/client";

export enum NotificationSettingsDefaultValues {
    EMAIL = 1,
    PUSH = 0
}

export const GET_NOTIFICATION_SETTINGS_FOR_USER = gql`
    query GetNotificationSettingsForUser {
        email: ums_usersettings(where: { key: { _eq: "EVENTS.EMAILACTIVE" } }) {
            id
            key
            value
        }

        push: ums_usersettings(where: { key: { _eq: "EVENTS.PUSHACTIVE" } }) {
            id
            key
            value
        }
    }
`;

export const GET_USER_SETTING = gql`
    query GetUserSetting($userid: uuid!, $key: String) {
        user_setting: ums_usersettings(where: { userid: { _eq: $userid }, key: { _eq: $key } }) {
            id
            value
        }
    }
`;

export const UPSERT_NOTIFICATION_SETTINGS_FOR_USER = gql`
    mutation UpsertNotificationSettingsForUser($objects: [ums_usersettings_insert_input!]!) {
        insert_ums_usersettings(
            objects: $objects
            on_conflict: { constraint: usersettings_customerid_userid_key, update_columns: value }
        ) {
            returning {
                id
                key
                value
            }
        }
    }
`;
